import React, { useState } from 'react';
import BlockContainer from '../BlockContainer';
import PapersignPricing from './PapersignPricing';
import PaperformPricing from './PaperformPricing';
import { Consumer } from '../../../context';

function Pricing({ title, description, product, showFeatures }) {
  const [annual, setAnnual] = useState(true);

  return (
    <BlockContainer
      id="pricing"
      title={title}
      description={description}
      bgColor="var(--white)"
      fullWidth
    >
      <div className="text-sm lg:leading-[40px] lg:text-[20px] bg-stone inline-block rounded-full mb-10">
        <button
          type="button"
          onClick={() => setAnnual(false)}
          className={`px-10 m-0 rounded-full transition-all transition-500 py-2 ${
            !annual ? `bg-midnight text-white ` : 'pr-8'
          } `}
        >
          Monthly
        </button>
        <button
          type="button"
          onClick={() => setAnnual(true)}
          className={`px-10 m-0 rounded-full  transition-all transition-500  py-2 ${
            annual ? `bg-midnight  text-white ` : 'pl-8'
          } `}
        >
          Yearly
        </button>
      </div>
      <div
        className={`overflow-x-auto lg:overflow-x-hidden  mx-auto flex flex-col items-center${
          title || description ? ' mt-10' : ''
        }`}
      >
        <div className="mx-auto !px-0">
          <div className="lg:px-[50px]">
            {product === 'papersign' && (
              <PapersignPricing annual={annual} showFeatures={showFeatures} />
            )}
            {product === 'paperform' && (
              <PaperformPricing annual={annual} showFeatures={showFeatures} />
            )}
          </div>
        </div>
      </div>
    </BlockContainer>
  );
}

export default function PricingWithContext(props) {
  return <Consumer>{(ctx) => <Pricing {...props} ctx={ctx} />}</Consumer>;
}
